import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { CredentialsService } from '@lib/core/authentication/credentials.service';
import { firstValueFrom, map } from 'rxjs';
import { BoltOnService } from '../services/bolt-on.service';
import { ContentService } from '../services/content.service';
import { ListService } from '../services/list.service';
import { decodeBase64 } from '../utils/base64.util';

@Injectable()
export class ContentResolver {
  constructor(
    private router: Router,
    private contentService: ContentService,
    private listService: ListService,
    private boltOnService: BoltOnService,
    private credentialsService: CredentialsService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    try {
      const blockTitle = decodeBase64(route.queryParams?.title);
      const lessonPlan = decodeBase64(route.queryParams?.lessonPlan);
      const contentId = route.paramMap.get('contentId');
      const keyStageId = route.paramMap.get('keyStage');
      const parentListBlock = await this.listService.getListBlockByContentId(contentId, route);
      const boltOns = await firstValueFrom(this.boltOnService.getBoltOns(true));
      const rows = await firstValueFrom(
        (await this.contentService.getRowsQuery(contentId, route, keyStageId))
          .get()
          .pipe(map((snapshot) => snapshot.docs.map((a) => ({ id: a.id, ...a.data() })))),
      );

      const content = {
        title: blockTitle,
        lessonPlan,
        boltOnBadges: this.boltOnService.getVisibleBoltOnBadges(parentListBlock?.boltOnIds || [], boltOns),
        boltOnIcons: this.boltOnService.getVisibleBoltOnIcons(parentListBlock?.boltOnIds || [], boltOns),
        rows: await Promise.all(
          rows.map(async (row) => {
            const blocks = await firstValueFrom(
              (await this.contentService.getBlocksQuery(contentId, row.id, route))
                .get()
                .pipe(map((snapshot) => snapshot.docs.map((a) => ({ id: a.id, ...a.data() })))),
            );
            return { ...row, blocks };
          }),
        ),
      };

      return content;
    } catch (error) {
      console.error(error);
      this.router.navigate(['/problem-with-the-service']);
      return Promise.reject();
    }
  }
}
